export default function install(Vue, options) {
  var vm = new Vue({
    data: {},
    methods: {
      logError(filename, error, msg) {
        msg = msg === "" ? "" : ` --> ${msg}`;

        var seperator = "-------------------------------------";

        console.log(seperator);
        console.log(`${filename}: Error ${msg}`);
        console.log(error);
        console.log(seperator);
      }
    }
  });

  // Object.defineProperties(Vue.prototype, {
  //   "$logError": {
  //     "get": function () {
  //       return vm.logErrors
  //     },
  //     "set": function (value) {
  //       vm.logErrors = value
  //       return this
  //     }
  //   }
  // })
}



//////////////////
// WEBPACK FOOTER
// ./Helpers/Plugins/logError.js
// module id = null
// module chunks = 